module.exports = __webpack_public_path__ + "media/packs/images/star-4755e7691192a2f626a394fe3bd432fe.svg";